import { NeuPagination } from "@neutron/react";

/**
 * A thin wrapper around `<NeuPaginator>`
 * @NeutronUpdate `<NeuPaginator>` gets replaced with `<NeuPagination>`
 * `total` needs to get replaced with `results`
 * `rowsPerPage` needs to get replaced with `limit`
 * `currentPage` needs to get replaced with `current`
 * `NeuPaginatorCustomEvent<NeuPaginatorChangedEventDetails>` needs to get replaced with `NeuPaginationCustomEvent<NeuPaginationChangeEvent>`
 * */
export function Paginator(props: {
    /** The total number of results we got back */
    total?: number,
    /** The size of the table itself. Equivalent to `rowsPerPage` or a limit you'd pass into SQL */
    size?: number,
    page?: number,
    onChange?: (value: any) => void,
}) {
    return (
        <NeuPagination results={props.total} limit={props.size} current={props.page} onNeuChange={props.onChange} />
    )
}